module.exports = __webpack_public_path__ + "static/media/loader.b2efa32f.svg";